import React from "react";
import DashboardLayout from "../../layout/DashboardLayout";
import MainContent from "../../components/CompletedAssessments/MainContent";

const CompletedAssessments = () => {
  return (
    <DashboardLayout>
      <MainContent />
    </DashboardLayout>
  );
};

export default CompletedAssessments;

